module.exports = __webpack_public_path__ + "img/tobahotel-2440x1172.c288b965.jpg";